<ng-container *transloco="let t">
  <ng-container *ngIf="input$ | async as input">
    <div>
      <button mat-flat-button type="button" color="accent" (click)="viewObjectData(jsonTmpl, input)">
        <mat-icon>visibility</mat-icon>
        {{t('input-object-report.viewObjectData')}}
      </button>

      <ng-template #jsonTmpl>
        <form [formGroup]="jsonForm">
          <ngx-monaco-editor class="jsonEditor" [options]="codeEditorOptions" formControlName="json">
          </ngx-monaco-editor>
        </form>
      </ng-template>
    </div>
  </ng-container>
</ng-container>
